// Language code to name mapping
export const LANGUAGE_NAMES = {
  'ab': 'Abkhazian',
  'ace': 'Acehnese',
  'ach': 'Acholi',
  'af': 'Afrikaans',
  'ak': 'Akan',
  'alz': 'Alur',
  'am': 'Amharic',
  'ar': 'Arabic',
  'as': 'Assamese',
  'awa': 'Awadhi',
  'ay': 'Aymara',
  'az': 'Azerbaijani',
  'ba': 'Bashkir',
  'ban': 'Balinese',
  'bbc': 'Batak Toba',
  'be': 'Belarusian',
  'bem': 'Bemba',
  'bew': 'Betawi',
  'bg': 'Bulgarian',
  'bho': 'Bhojpuri',
  'bik': 'Bikol',
  'bm': 'Bambara',
  'bn': 'Bengali',
  'br': 'Breton',
  'bs': 'Bosnian',
  'bts': 'Batak Simalungun',
  'btx': 'Batak Karo',
  'bua': 'Buryat',
  'ca': 'Catalan',
  'ceb': 'Cebuano',
  'cgg': 'Chiga',
  'chm': 'Mari',
  'ckb': 'Central Kurdish',
  'cnh': 'Hakha Chin',
  'co': 'Corsican',
  'crh': 'Crimean Tatar',
  'crs': 'Seychellois Creole',
  'cs': 'Czech',
  'cv': 'Chuvash',
  'cy': 'Welsh',
  'da': 'Danish',
  'de': 'German',
  'din': 'Dinka',
  'doi': 'Dogri',
  'dov': 'Dombe',
  'dv': 'Divehi',
  'dz': 'Dzongkha',
  'ee': 'Ewe',
  'el': 'Greek',
  'en': 'English',
  'eo': 'Esperanto',
  'es': 'Spanish',
  'et': 'Estonian',
  'eu': 'Basque',
  'fa': 'Persian',
  'ff': 'Fulah',
  'fi': 'Finnish',
  'fj': 'Fijian',
  'fr': 'French',
  'fy': 'Western Frisian',
  'ga': 'Irish',
  'gaa': 'Ga',
  'gd': 'Scottish Gaelic',
  'gl': 'Galician',
  'gn': 'Guarani',
  'gom': 'Goan Konkani',
  'gu': 'Gujarati',
  'ha': 'Hausa',
  'haw': 'Hawaiian',
  'he': 'Hebrew',
  'hi': 'Hindi',
  'hil': 'Hiligaynon',
  'hmn': 'Hmong',
  'hr': 'Croatian',
  'hrx': 'Hunsrik',
  'ht': 'Haitian Creole',
  'hu': 'Hungarian',
  'hy': 'Armenian',
  'id': 'Indonesian',
  'ig': 'Igbo',
  'ilo': 'Iloko',
  'is': 'Icelandic',
  'it': 'Italian',
  'iw': 'Hebrew',
  'ja': 'Japanese',
  'jv': 'Javanese',
  'jw': 'Javanese',
  'ka': 'Georgian',
  'kk': 'Kazakh',
  'km': 'Khmer',
  'kn': 'Kannada',
  'ko': 'Korean',
  'kri': 'Krio',
  'ktu': 'Kituba',
  'ku': 'Kurdish',
  'ky': 'Kyrgyz',
  'la': 'Latin',
  'lb': 'Luxembourgish',
  'lg': 'Luganda',
  'li': 'Limburgish',
  'lij': 'Ligurian',
  'lmo': 'Lombard',
  'ln': 'Lingala',
  'lo': 'Lao',
  'lt': 'Lithuanian',
  'ltg': 'Latgalian',
  'luo': 'Luo',
  'lus': 'Mizo',
  'lv': 'Latvian',
  'mai': 'Maithili',
  'mak': 'Makasar',
  'mg': 'Malagasy',
  'mi': 'Maori',
  'min': 'Minangkabau',
  'mk': 'Macedonian',
  'ml': 'Malayalam',
  'mn': 'Mongolian',
  'mni-Mtei': 'Meiteilon (Manipuri)',
  'mr': 'Marathi',
  'ms': 'Malay',
  'ms-Arab': 'Malay (Jawi)',
  'mt': 'Maltese',
  'my': 'Myanmar (Burmese)',
  'ne': 'Nepali',
  'new': 'Newari',
  'nl': 'Dutch',
  'no': 'Norwegian',
  'nr': 'South Ndebele',
  'nso': 'Northern Sotho',
  'nus': 'Nuer',
  'ny': 'Chichewa',
  'oc': 'Occitan',
  'om': 'Oromo',
  'or': 'Odia (Oriya)',
  'pa': 'Punjabi',
  'pa-Arab': 'Punjabi (Shahmukhi)',
  'pag': 'Pangasinan',
  'pam': 'Pampanga',
  'pap': 'Papiamento',
  'pl': 'Polish',
  'ps': 'Pashto',
  'pt': 'Portuguese',
  'qu': 'Quechua',
  'rn': 'Rundi',
  'ro': 'Romanian',
  'rom': 'Romani',
  'ru': 'Russian',
  'rw': 'Kinyarwanda',
  'sa': 'Sanskrit',
  'scn': 'Sicilian',
  'sd': 'Sindhi',
  'sg': 'Sango',
  'shn': 'Shan',
  'si': 'Sinhala',
  'sk': 'Slovak',
  'sl': 'Slovenian',
  'sm': 'Samoan',
  'sn': 'Shona',
  'so': 'Somali',
  'sq': 'Albanian',
  'sr': 'Serbian',
  'ss': 'Swati',
  'st': 'Southern Sotho',
  'su': 'Sundanese',
  'sv': 'Swedish',
  'sw': 'Swahili',
  'szl': 'Silesian',
  'ta': 'Tamil',
  'te': 'Telugu',
  'tet': 'Tetum',
  'tg': 'Tajik',
  'th': 'Thai',
  'ti': 'Tigrinya',
  'tk': 'Turkmen',
  'tl': 'Filipino',
  'tn': 'Tswana',
  'tr': 'Turkish',
  'ts': 'Tsonga',
  'tt': 'Tatar',
  'ug': 'Uyghur',
  'uk': 'Ukrainian',
  'ur': 'Urdu',
  'uz': 'Uzbek',
  'vi': 'Vietnamese',
  'xh': 'Xhosa',
  'yi': 'Yiddish',
  'yo': 'Yoruba',
  'yua': 'Maya',
  'yue': 'Cantonese',
  'zh': 'Chinese (Simplified)',
  'zh-CN': 'Chinese (Simplified)',
  'zh-TW': 'Chinese (Traditional)',
  'zu': 'Zulu'
};

// Convert API language response to our format: { language, name }
export const mapLanguageResponse = (languages) => {
  return languages.map((item) => {
    const code = (item.language || '').toString();
    const displayName = item.name || LANGUAGE_NAMES[code] || code.toUpperCase();
    return { language: code, name: displayName };
  });
};

// Get popular languages for fallback
export const getPopularLanguages = () => [
  { language: 'EN', name: 'English' },
  { language: 'ES', name: 'Spanish' },
  { language: 'FR', name: 'French' },
  { language: 'DE', name: 'German' },
  { language: 'IT', name: 'Italian' },
  { language: 'PT', name: 'Portuguese' },
  { language: 'RU', name: 'Russian' },
  { language: 'ZH-HANS', name: 'Chinese (Simplified)' },
  { language: 'JA', name: 'Japanese' },
  { language: 'AR', name: 'Arabic' },
  { language: 'HI', name: 'Hindi' },
  { language: 'KO', name: 'Korean' },
  { language: 'TH', name: 'Thai' },
  { language: 'VI', name: 'Vietnamese' },
  { language: 'TR', name: 'Turkish' },
  { language: 'PL', name: 'Polish' },
  { language: 'NL', name: 'Dutch' },
  { language: 'SV', name: 'Swedish' },
  { language: 'DA', name: 'Danish' },
  { language: 'NO', name: 'Norwegian' }
];

// Get language name by code
export const getLanguageName = (code) => {
  return LANGUAGE_NAMES[code] || code.toUpperCase();
}; 